export enum StuutApiErrorCodes {
  StuutError = 'StuutError',
  AuthenticationError = 'AuthenticationError',
  AuthorizationError = 'AuthorizationError',
  EntityNotFoundError = 'EntityNotFoundError',
  OrganizationNotFoundError = 'OrganizationNotFoundError',
}

export interface ListResponse {
  data: any[];
  current_page?: number;
  next_page?: number;
  total_records?: number;
}

export interface OutreachWorkflowDefaults {
  outreach_window_start: string;
  outreach_window_end: string;
  timezone: string;
  active_days: number[];
}
